import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Switch,
  FormControl,
  Typography,
  Avatar } from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import GuiaApi from '../../api/GuiaApi';
import ElementoApi from '../../api/ElementoApi';

const styles = theme => ({
  dialogTitleTypography: {
    marginLeft: theme.spacing(1.5),
    marginTop: theme.spacing(1.5),
    display: 'inline',
    fontSize: 23
  },
  dialogTitle: {
    display: 'inline-flex',
  },
  fontTable: {
    fontSize: 12
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12,
    display: 'inline-flex',
  },
  paperTable: {
    // maxHeight: '35vh'
  },
  disclaimer: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  }
});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '0px',
        },
      },
    }
  });
class FormDialogElementosPermissaoTroca extends React.Component {
  elementoApi = new ElementoApi();
  state = {
    elementos: [],
    fetching: false,
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    let elementos = await this.elementoApi.recuperarElementosTrocaPermissaoRecurso(this.props.codLoteGuia, this.props.codGuia);
    this.setState({elementos: elementos, fetching: false});
  }
  handleChangeSwitch = async (event, tableMeta) => {
    this.setState({fetching: true});
    await this.elementoApi.alterarPermissaoTrocaItem(this.props.codLoteGuia, this.props.codGuia,this.state.elementos[tableMeta.rowIndex][0]);
    let elementos = await this.elementoApi.recuperarElementosTrocaPermissaoRecurso(this.props.codLoteGuia, this.props.codGuia);
    this.setState({elementos: elementos, fetching: false});
  };  
  render () {
    const options = {
      customToolbarSelect: () => {},
      print: false,
      download: false,
      selectableRows: 'none',
      filterType: 'dropdown',
      rowsPerPageOptions: [50, 100, 500, 1000, 1500],
      rowsPerPage: 50,
      viewColumns: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>guia(s) selecionada(s)</Typography>
        },
      }
    };
    const columns = [
      {
        name: 'id',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Data Realização',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Tabela',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Item',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'codItemTabela',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codTipoItem',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Qtd. Solic.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Qtd. Aut.',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Vl. Unit. Solic.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },      
      {
        name: 'Vl. Unit. Aut.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },
      {
        name: 'Vl. Tot. Solic.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },
      {
        name: 'Vl. Tot. Aut.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },
      {
        name: 'txtMotivoRecurso',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Pode Trocar Item?',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <FormControl>
                <Switch
                  checked={value === 'S' ? true : false}
                  onChange={event => this.handleChangeSwitch(event, tableMeta)}
                  color='primary'
                />
            </FormControl>      
            );
          },
        }
      },
      {
        name: 'indDesistiuRecorrer',
        options: {
          display: 'excluded',
          filter: false,
        }
      },

    ];
    const { open, titulo, classes, handleClose } = this.props;
    const { elementos, fetching } = this.state;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xl'
          scroll='body'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle className={classes.dialogTitle}>
            <Typography className={classes.dialogTitleTypography}>{titulo}</Typography> 
            <Avatar className={classes.avatar}>{elementos.length}</Avatar>
          </DialogTitle>
          <DialogContent>
            {fetching ? <LinearProgressBlockScreen />
              : <Paper className={classes.paperTable}>
                <Typography className={classes.disclaimer}>Abaixo estão listados os itens da guia recorrida em que houve glosa parcial. Altere os itens que poderão ter seus códigos trocados pelo prestador na guia de recurso.</Typography>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={elementos}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </Paper>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogElementosPermissaoTroca);
